import React, { useId } from "react";

// Bootstrap carousel for banners from the API: [{ src, alt, url? }].
// Renders nothing when there are no banners; a banner without a url is not a link.
const ImageSlider = ({ banners, className = "mt-5 mb-0" }) => {
  const carouselId = `carousel-${useId().replace(/:/g, "")}`;
  if (!banners || banners.length === 0) return null;

  return (
    <div className={className}>
      <div id={carouselId} className="carousel slide" data-bs-ride="carousel">
        {banners.length > 1 && (
          <div className="carousel-indicators">
            {banners.map((_, index) => (
              <button
                key={index}
                type="button"
                data-bs-target={`#${carouselId}`}
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
                aria-current={index === 0 ? "true" : undefined}
                aria-label={`Slide ${index + 1}`}
              ></button>
            ))}
          </div>
        )}

        <div className="carousel-inner">
          {banners.map((banner, index) => {
            const image = (
              <img
                src={banner.src}
                alt={banner.alt || ""}
                className="d-block w-100 h-100"
                style={{ objectFit: "cover" }}
              />
            );
            return (
              <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                <div className="rounded-3 overflow-hidden" style={{ aspectRatio: "2100 / 500" }}>
                  {banner.url ? (
                    <a href={banner.url} style={{ display: "block", width: "100%", height: "100%" }}>
                      {image}
                    </a>
                  ) : (
                    image
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {banners.length > 1 && (
          <>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target={`#${carouselId}`}
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
                style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", padding: "1rem", borderRadius: "50%" }}
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target={`#${carouselId}`}
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
                style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", padding: "1rem", borderRadius: "50%" }}
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ImageSlider;
